import React from 'react';

import styled from '@emotion/styled';

import { DriverDetailsDataType } from '../../../hooks/dashboard/driver-list/useDriverDetails';
import IncidentDistribution from './IncidentDistribution';
import DrivePerformanceChart from './LineChart/DrivePerformanceChart';
import StatsCard from './StatsCard';

interface PerformanceIndexProps {
  driverDetailsData: DriverDetailsDataType;
  refreshData: number;
}

const PerformanceIndex: React.FC<PerformanceIndexProps> = ({
  driverDetailsData,
  refreshData,
}) => {
  return (
    <Container>
      <StatsCard data={driverDetailsData} />
      <DrivePerformanceChart />
      <IncidentDistribution key={refreshData} />
    </Container>
  );
};

export default PerformanceIndex;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
